namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerEditor()
    export class LookupCoupons extends
        Serenity.LookupEditorBase<Serenity.LookupEditorOptions, any> {

        public myId: string;

        constructor(container: JQuery, opt: Serenity.LookupEditorOptions) {
            super(container, opt);
        }

        protected getLookupKey() {
            return this.buildLookupKey(this.myId);
        }

        protected getItems(lookup: Q.Lookup<any>) {
            var customLookup = Q.getLookup(this.buildLookupKey(this.myId));

            let items: any = super.getItems(customLookup);           
           
            items = items.filter(x => Q.toId(x.EndBillPmType) == this.myId); // here 'Id' field is hardcode for demo

            return items;
        }

        private buildLookupKey(id?: string): string {


                return "AdvPromo.LookupAvPromoCouponTypes";
          
        }
    }    
}